import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';

function EventCheckOutButton(props) {
    const [isDisabled, setIsDisabled] = useState(null);

    const handleCheckOutClick = () => {
        setIsDisabled(true);
        props.updateDialogVisible(true);
    }

    useEffect(() => {
        const shouldDisable =
            props.round.starttime !== null && props.round.starttime !== ''
        setIsDisabled(shouldDisable);
    }, [props.round, props.dialogDisplay]);

    if (isDisabled === null) return null; // shouldDisable完了まで描画しない
    return (
        <Button variant="contained" color="primary" onClick={handleCheckOutClick} disabled={isDisabled}>
            ルームを解散する
        </Button>
    );

}

export default EventCheckOutButton;
